import script from "./ClientProjectRealTimePlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectRealTimePlot.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectRealTimePlot.vue?vue&type=style&index=0&id=8cc4acbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cc4acbc"]])

export default __exports__